"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.app = void 0;
var base_1 = require("./base");
exports.app = {
    base: base_1.appURL,
    healthTool: "".concat(base_1.appURL, "/recommendation-tool/health"),
    recommendationTool: "".concat(base_1.appURL, "/recommendation-tool"),
    myPolicies: "".concat(base_1.appURL, "/me/policies"),
};
